export default __webpack_public_path__ + "static/index-title-news-ja-4c83245dbd36f142120ad99bf73e9e72.png";